import React from "react";

const AgeInput: React.FC<{
  name: string;
  label: string;
  inputLabel?: string;
  value?: any;
  status?: string;
  disabled?: boolean;
  onChange?: any;
  min?: any;
  max?: any;
}> = (props) => {
  // const checkNumValue = (num: number) => {
  //   console.log(num);
  //   if (num < props?.min) {
  //     return props?.min;
  //   } else if (num > props?.max) {
  //     return props?.max;
  //   } else {
  //     return num;
  //   }
  // };

  return (
    <div className={`input-age-container ${props.status}`}>
      <label>{props.label}</label>
      <input
        name={props.name}
        type="number"
        placeholder={props.inputLabel ? props.inputLabel : props.label}
        step={1}
        value={props.value}
        // value={checkNumValue(props.value)}
        disabled={props.disabled || false}
        // onChange={(event) => props.onChange(event.target.value)}
        onChange={props.onChange ? props.onChange : () => {}}
        required={true}
        min={1}
        max={140}
      />
    </div>
  );
};

export default AgeInput;
